<template>
  <div>
    <section class="grid-flex column">
      <div class="box w100">
        <!-- account -->
        <div class="box-content">
          <div class="flex row">
            <!-- form account info -->
            <div class="flex-1 account">
              <h4>Dados de cadastro</h4>
              <div class="flex column margin-top-m">
                <div class="flex-1 w100">
                  <label>ID</label>
                  <input
                    class="input"
                    type="text"
                    v-model="account.id"
                    disabled=""
                    readonly=""
                  />
                </div>

                <div class="flex-1 w100 margin-top-m">
                  <label>Nome</label>
                  <input class="input" type="text" v-model="account.name" />
                </div>

                <div v-if="false" class="flex-1 w100 margin-top-m">
                  <label>Preferência de Moeda</label>
                  <select class="input" v-model="account.currency_preference">
                    <option v-for="(c, index) in listCurrency" :key="index" :value="c.value" :selected="c.value === account.currency_preference">
                      {{ c.label }}
                    </option>
                  </select>
                </div>

              
                <div class="flex-1 w100 margin-top-m">
                  <label
                    >Taxa de Imposto (Adicionar o valor em percentual)</label
                  >
                  <div class="flex-1">
                    <input
                      class="input"
                      style="width: 90px; min-width:90px"
                      :max="100"
                      :min="0"
                      type="number"
                      v-model="account.tax_rate"
                    />
                    %
                  </div>
                  <p>
                    <small
                      >O imposto é calculado seguindo a seguinte fórmula:
                    </small>
                  </p>
                  <div class="filter-item">
                    <select class="input" v-model="account.tax_type">
                      <option v-for="(c, index) in listTaxType" :key="index" :value="c.value" :selected="c.value === account.tax_type">
                        {{ c.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="flex-1 w100 margin-top-m">
                  <label
                    >Time Zone</label
                  >
                  <div class="filter-item">
                    <select class="input" v-model="account.timezone">
                      <option v-for="(c, index) in listTimeZone" :key="index" :value="c.value" :selected="c.value === account.tax_type">
                        {{ c.label }}
                      </option>
                    </select>
                  </div>
                </div>

              </div>
              <div class="flex center margin-top-l">
                <div class="button primary" @click="updateAccount()">
                  SALVAR
                </div>
              </div>
            </div>
            <!-- subscription info -->
            <div v-if="account.account_type === 'MANAGER'" class="flex-1 subscription">
              <h2>Assinatura</h2>
              <div class="margin-top-s">
                Nome do Plano: <b>{{ account && account.plan }}</b>
              </div>

              <div class="margin-top-l">
                <h3>
                  Status: {{ _decode_s(account.status) }}
                </h3>
              </div>
              
              <div v-if="!isFreemium" class="margin-top-l">

                <div v-if="isAccountLimitExceeded" class="margin-top-l">
                  <h3 style="color:red">Atenção: Você passou do limite de pedidos pagos no mês para seu plano.</h3>
                  <br>
                  <p>Para continuar usando o sistema é necessário fazer o upgrade de plano clicando no botão abaixo:</p>
                </div>

                <!-- stripe panel -->
                <div v-if="isStripe">
                  <button @click="generateSessionStripe()" class="button primary">
                    {{  isAccountLimitExceeded ? 'Fazer Upgrade de Plano' : 'Gerenciar Assinatura' }}
                  </button>
                </div>
                <div v-else>
                  <a href="https://kiwify.com.br" target="_blank">
                    <button class="button primary">
                      Gerenciar Assinatura (KIWIFY)
                    </button>
                  </a>
                </div>
                <div class="margin-top-l">
                  <p>
                    Clique no botão gerenciar assinatura para conseguir realizar as tarefas abaixo:
                  </p>
                  <ul>
                    <li>Alteração de Cartão.</li>
                    <li>Alteração de Plano.</li>
                    <li>Cancelamento</li>
                  </ul>
                  <p>Caso ainda tenha dúvidas. Enviar e-mail para:</p>
                  <p class="margin-top-s">contato@unicotracker.com.br</p>
                </div>
              </div>
              <div v-else>
                <div class="margin-top-l">
                  <h2>Você está no plano gratuito.</h2>
                  <p class="margin-top-l">
                    Faça uma assinatura para remover a mensagem de aviso e continuar usando o sistema.!
                  </p>
                </div>
                <div class="margin-top-l">
                  <router-link  :to="{ name: 'Subscription', params: {} }">
                    <button class="button primary">
                      {{  isAccountLimitExceeded ? 'Fazer Upgrade de Plano (ASSINAR)' : 'FAZER UPGRADE (CLIQUE AQUI)' }}
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- PROJECT ACCOUNT -->
            <div v-else class="flex-1 subscription">
              <h2>Assinatura</h2>
                <div class="margin-top-l">
                  <h3>
                    Status: {{ _decode_s(account.status) }}
                  </h3>
                </div>
                <div class="margin-top-l">
                  <h3>Você está em uma conta projeto!</h3>
                  <p>Para gerênciar a assinatura você precisa acessar a conta administradora do projeto.</p>
                </div>
                <div class="margin-top-l">
                  <p>Entre em contato com o administrador da conta:</p>
                  <br>
                  <p>
                    <b>{{ account.account_manager_name }}</b>
                  </p>
                </div>
                
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import moment from "moment-timezone";

import { mapState } from "vuex";

import { updateAccount } from "@/services/account";

import {
  createSessionStripe,
} from "@/services/subscription";

export default {
  name: "config-account",
  components: {
  },
  data() {
    return {
      loading: false,
      listCurrency: [
        {
          value: 'BRL',
          label: 'Real Brasileiro (BRL)'
        },
        {
          value: 'USD',
          label: 'Dólar Americano (USD)'
        }
      ],
      listTaxType: [
        {
          value: 'RECEITA',
          label: '(Pedidos Aprovados) x Taxa de imposto'
        },
        {
          value: 'RECEITA-PRODUTO',
          label: '(Pedidos Aprovados - Custo de Produto) x Taxa de imposto'
        },
        {
          value: 'LUCRO',
          label: '(Pedidos Aprovados - Custo de Marketing - Custo de Produto) x Taxa de imposto'
        },
      ],
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isStripe() {
      //return this.account && this.account.payment_platform === 'STRIPE'
      return false
    },
    isFreemium() {
      return this.account && this.account.plan && this.account.plan.toLowerCase().includes('freemium')
    },
    isAccountLimitExceeded() {
      return this.account && this.account.status === 'LIMIT_EXCEEDED'
    },
    listTimeZone() {
      const timezones = moment.tz.names()

      return timezones.map(e => { return { label: e, value: e }})
    },
  },
  methods: {
    _decode_s(status) {
      var _m = {
        'BLOCKED': 'BLOQUEADA',
        'CALCELED': 'CANCELADA',
        'ACTIVE': 'ATIVA',
      }

      return _m[status] || status
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    generateSessionStripe() {
      createSessionStripe()
        .then(result => {
          window.location.href = result.recirect_url;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao criar sessão na STRIPE"
          });
        });
    },
    updateAccount() {
      let params = {
        name: this.account.name,
        tax_rate: this.account.tax_rate,
        tax_type: this.account.tax_type,
        timezone: this.account.timezone,
        currency_preference: this.account.currency_preference,
      };
      updateAccount(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Conta atualizada com sucesso",
          });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao atualizar conta",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.account {
  padding: 16px;
  border-right: 1px solid #c2c2c235;
}

.subscription {
  padding: 16px;
  ul {
    padding-left: 15px;
    li {
      // list-style-type: none;
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
}

.list-projects {
  width: 100%;
  li {
    list-style-type: none;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #c2c2c258;
  }
}

.actions {
  > div {
    margin-left: 4px;
  }
}

</style>
